declare let THREE: any;

interface IObjectWorldPosition {
  setObjectWorldPosition: (position) => IObjectOffset;
}

interface IObjectOffset {
  setOffset: (position) => IPlaneNormal;
}

interface IPlaneNormal {
  setNormal: (normal) => ISizeCalculator;
}

export interface ISizeCalculator {
  calculate: (ray, scaleDirection) => number;
}

export class NewSizeCalculator implements IObjectWorldPosition, IObjectOffset, IPlaneNormal, ISizeCalculator {

  private plane = new THREE.Plane();
  private startPoint = new THREE.Vector3();
  private endPoint = new THREE.Vector3();
  private objectWorldPosition = new THREE.Vector3();

  static Create = (): IObjectWorldPosition => new NewSizeCalculator();

  private constructor() {
  }

  setObjectWorldPosition(objectWorldPosition): IObjectOffset {
    this.objectWorldPosition.copy(objectWorldPosition);
    return this;
  }

  setOffset(offset): IPlaneNormal {
    this.startPoint.copy(this.objectWorldPosition);
    this.startPoint.add(offset);
    return this;
  }

  setNormal(normal): ISizeCalculator {
    this.plane.setFromNormalAndCoplanarPoint(normal, this.objectWorldPosition);
    return this;
  }

  calculate(ray, scaleDirection): number {
    ray.intersectPlane(this.plane, this.endPoint);
    return Math.floor(this.endPoint
      .sub(this.startPoint)
      .projectOnVector(scaleDirection)
      .length()
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/Shared/ObjectResize/NewSizeCalculator.ts